module.exports = __webpack_public_path__ + "static/media/BM 03.5896a98d.png";